import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQS = [
  {
    question: "Which brokers are supported?",
    answer:
      "Dhan, Zerodha Kite Connect and ICICI Direct (Breeze API) are supported today, with more integrations planned.",
  },
  {
    question: "Is my trading account secure?",
    answer:
      "Broker credentials and session tokens are encrypted at rest, connections use your broker's own official API/OAuth flow, and TekStar Invest continuously monitors connection health.",
  },
  {
    question: "Do you hold customer funds?",
    answer:
      "No. TekStar Invest never holds your funds or securities — every order is placed through your own connected broker account.",
  },
  {
    question: "Can I use my existing broker account?",
    answer:
      "Yes. Connect the Dhan, Zerodha or ICICI Direct account you already have in a few clicks — no new brokerage account required.",
  },
];

export function FaqSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 }, bgcolor: "grey.50" }}>
      <Container maxWidth="sm">
        <Typography variant="h4" fontWeight={800} textAlign="center" mb={7}>
          Frequently asked questions
        </Typography>

        {FAQS.map((faq, index) => (
          <Accordion key={faq.question} defaultExpanded={index === 0} disableGutters elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, mb: 1.5, "&:before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1" fontWeight={600}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}

export default FaqSection;
